import {Component, Input, OnInit} from '@angular/core';
import {revealExpand, rotateArrow, CardState} from '../../../animations';

@Component({
  selector: 'as-expand',
  templateUrl: './expand.component.html',
  styleUrls: ['./expand.component.scss'],
  animations: [revealExpand, rotateArrow ]
})
export class ExpandComponent implements OnInit {
  @Input() count: number;
  @Input() label;
  @Input() htmlLabel;
  state = [];
  constructor() {
  }

  ngOnInit() {
    this.state.push(CardState.Closed)
  }
  expandSubList(index) {
    this.state[index] = ( this.state[index] == CardState.Open) ? CardState.Closed : CardState.Open;
  }
}
